// packages/world-model/src/traits/supporter/index.ts

export { SupporterTrait } from './supporterTrait';
export { SupporterBehavior, type IAddItemToSupporterResult, type IRemoveItemFromSupporterResult } from './supporterBehavior';
